function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import './editor-form.scss';
var EditorFormComponentCtrl = /*#__PURE__*/function () {
  EditorFormComponentCtrl.$inject = ["$log", "NotifService"];
  function EditorFormComponentCtrl($log, NotifService) {
    _classCallCheck(this, EditorFormComponentCtrl);
    _defineProperty(this, "edit", {
      item: {}
    });
    this.$log = $log;
    this.NotifService = NotifService;
  }
  return _createClass(EditorFormComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[EditorFormComponentCtrl] onInit');
    }
  }, {
    key: "guardar",
    value: function guardar() {
      var _this = this;
      this.editor.guardar(this.edit.item).then(function () {
        _this.NotifService.good('Datos guardados');
      });
    }
  }, {
    key: "nuevo",
    value: function nuevo() {
      var _this2 = this;
      this.editor.nuevo(this.edit.item).then(function () {
        _this2.NotifService.good('Datos guardados');
      });
    }
  }]);
}();
angular.module('candidato').component('editorForm', {
  bindings: {
    editor: '<'
  },
  transclude: true,
  controller: EditorFormComponentCtrl,
  template: require('./editor-form.component.html')
});